import { DownloadCouponPageProps } from 'src/pages/DownloadCouponPage/index'
import DownloadCouponLayout from 'src/pages/DownloadCouponPage/_components/DownloadCouponLayout'

const DownloadCouponPageView = ({ downloadCouponData }: DownloadCouponPageProps) => {
  return (
    <DownloadCouponLayout
      couponDetailData={downloadCouponData!}
      barcode={downloadCouponData?.Barcode!}
    />
  )
}

export default DownloadCouponPageView
